<template>
  <div class="row alert alert-warning">
    <div class="col-md-12">
      <!-- {{form_data}} -->
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Recurring:</label>
            <div class="checkbox">
              <input
                @change="updateRecurring"
                v-model="isRecurring"
                :key="1"
                type="checkbox"
                name="checkbox"
              />
            </div>
          </div>
        </div>
        <div class="col-md-3" v-if="isRecurring">
          <div class="form-group">
            <label>Frequency</label>
            <select @change="updateRecurring" v-model="form_data.recurrence" class="form-control">
              <option>-- Select --</option>
              <option
                v-for="(item,index) in recurrenceOptions"
                :key="item+index"
                :label="item"
                :value="item"
              >{{item}}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-3" v-if="isRecurring">
          <div class="form-group">
            <label>Set Time (HH:MM)</label>
            <br />
            <!-- {{start_hour}} -->
            <select @change="updateRecurring" style="width:50px;" v-model="start_hour">
              <option :value="''">-- Select --</option>
              <option :value="'00'">00</option>
              <option
                v-for="hour in 23"
                :key="hour"
                :value="(hour<10)?'0'+hour:hour"
              >{{(hour<10)?'0'+hour:hour}}</option>
            </select>
            <select @change="updateRecurring" style="width:50px;" v-model="start_minute">
              <option :value="''">-- Select --</option>
              <option :value="'00'">00</option>
              <option
                v-for="minute in 59"
                :key="minute"
                :value="(minute<10)?'0'+minute:minute"
              >{{(minute<10)?'0'+minute:minute}}</option>
            </select>
            <div classs="text-muted" style="font-size:11px;">Timezone in GMT+7 (Jakarta Time / WIB)</div>
          </div>
        </div>

        <div class="col-md-3" v-if="form_data.recurrence!='daily' && isRecurring">
          <div class="form-group" v-if="form_data.recurrence=='weekly'">
            <label>Every</label>
            <select
              @change="updateRecurring"
              v-model="form_data.recurrence_every"
              class="form-control"
            >
              <option>-- Select Day --</option>
              <option
                v-for="(item,index) in weeklyOptions"
                :key="item+index"
                :label="item"
                :value="item"
              >{{item}}</option>
            </select>
          </div>
          <div class="form-group" v-if="form_data.recurrence!='weekly'">
            <label>Every</label>
            <select
              @change="updateRecurring"
              v-model="form_data.recurrence_every"
              class="form-control"
            >
              <option>-- Select --</option>
              <option
                v-for="(item,index) in monthlyOptions"
                :key="item+index"
                :label="item"
                :value="item"
              >{{item}}</option>
            </select>
          </div>
        </div>
        <div
          class="col-md-3"
          v-if="form_data.recurrence!='daily' && form_data.recurrence!='weekly' && isRecurring"
        >
          <div class="form-group" v-if="form_data.recurrence=='annually'">
            <label>Select Month</label>

            <select
              @change="updateRecurring"
              v-model="form_data.recurrence_annually_month"
              class="form-control"
            >
              <option>-- Select --</option>
              <option
                v-for="(item,index) in annuallyMonthOptions"
                :key="item+index"
                :label="item"
                :value="item"
              >{{item}}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12" v-if="isRecurring">
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-3">
          <div class="form-group">
            <label>End Date</label>
            <select v-model="form_data.recurrence_end" class="form-control">
              <option>-- Select --</option>
              <option
                v-for="(item,index) in recurrenceEndOptions"
                :key="item+index"
                :label="item"
                :value="item"
              >{{item}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-3" v-if="form_data.recurrence_end!='never'">
          <div class="form-group">
            <label>Select Date</label>

            <input
              @change="updateRecurring"
              class="form-control datetimepicker"
              v-model="form_data.recurrence_end_date"
              type="date"
            />
            <!-- <datetime
              :min-datetime="currentDateTimeUTC()"
              :zone="'local'"
              input-class="form-control"
              value-zone="UTC"
              type="date"
              v-model="form_data.recurrence_end_date"
            ></datetime>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { currentDateTimeUTC, convertTzDatetimeToDateISO } from "@/utils/helper";
import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
export default {
  components: {
    Datetime
  },
  data() {
    return {
      start_hour: "00",
      start_minute: "01",
      getContentOptions: {},
      loading: false,
      isRecurring: false,
      recurrenceOptions: ["daily", "weekly", "monthly", "annually"],
      weeklyOptions: [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday"
      ],
      monthlyOptions: [
        "first",
        "last",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31"
      ],
      annuallyMonthOptions: [
        "january",
        "february",
        "march",
        "april",
        "may",
        "june",
        "july",
        "august",
        "september",
        "october",
        "november",
        "december"
      ],
      recurrenceEndOptions: ["never", "custom"],
      form_data: {
        recurrence: "daily",
        recurrence_time: this.start_hour + ":" + this.start_minute,
        recurrence_every: "",
        recurrence_annually_month: "",
        recurrence_end: "never",
        recurrence_end_date: ""
      }
    };
  },
  computed: {
    detailBroadcast() {
      return this.$store.state.omniwa.detailBroadcast;
    },
    broadcastParamSt() {
      return this.$store.state.omniwa.broadcastParamSt;
    },
    isShowBroadcast() {
      return this.$store.state.omniroom.isShowBroadcast;
    }
  },
  created() {},
  mounted() {
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
  },
  watch: {
    isShowBroadcast: {
      handler: function(val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          var that = this;
          setTimeout(function() {
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            if (
              that.broadcastParamSt.broadcast_id != "" &&
              that.detailBroadcast.is_recurring == 1
            ) {
              that.isRecurring = that.detailBroadcast.is_recurring;

              that.form_data = that.broadcastParamSt.recurring_form;
              if (that.isRecurring == 1) {
                let newTime = that.form_data.recurrence_time.split(":");
                // console.log("newwwwtime", newTime);
                if (newTime.length == 2) {
                  that.start_hour = newTime[0];
                  that.start_minute = newTime[1];
                }
              }
              console.log("that.form_datathat.form_data", that.form_data);
            } else {
              that.isRecurring = false;
              that.form_data = {
                recurrence: "daily",
                recurrence_every: "",
                recurrence_annually_month: "",
                recurrence_end: "never",
                recurrence_end_date: "",
                recurrence_time: that.start_hour + ":" + that.start_minute
              };
            }
          }, 100);
        }
      },
      deep: true
    }
  },
  methods: {
    convertTzDatetimeToDateISO(utcdatetime) {
      return convertTzDatetimeToDateISO(utcdatetime);
    },
    currentDateTimeUTC() {
      return currentDateTimeUTC();
    },
    updateRecurring() {
      let dataParam = this.broadcastParamSt;
      if (this.isRecurring == true) {
        dataParam.is_recurring = 1;
        dataParam.recurring_form.recurrence_time =
          this.start_hour + ":" + this.start_minute;
      } else {
        dataParam.is_recurring = 0;
      }
      dataParam.recurring_form = this.form_data;
      this.$store.dispatch("omniwa/actBroadcastParamSt", dataParam);
    },
    removeRecurring(recurringId) {
      this.form_data = {
        id: "",
        campaign_template_id: "",
        name: "",
        subject_line: "",
        email_from: "",
        email_message: "",
        from_name: "",
        reply_to_email: "",
        recurrence: "daily",
        recurrence_every: "",
        recurrence_annually_month: "",
        recurrence_end: "never",
        recurrence_end_date: "",
        recurrence_time: this.start_hour + ":" + this.start_minute
      };
      this.isRecurring = false;
    },

    resetRecurrenceEvery() {
      this.form_data.recurrence_every = "";
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/messageReport/scheduler.vue